import type { LoaderFunctionArgs } from '@remix-run/node';
import { getBuildHubInspirations } from '@modules/build-hub/api/get-build-hub-inspirations';
import type { GetBuildHubInspirationsQueryVariables } from 'generated/graphql';
export const LIST_BUILD_HUB_INSPIRATION_API_ROUTE =
    '/remix-api/app/build-hub-inspiration-list';

export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const urlSegment = url.searchParams.get('urlSegment');
    const limit = parseInt(url.searchParams.get('limit') || '40');
    const offset = parseInt(url.searchParams.get('offset') || '0');

    if (!urlSegment) {
        throw new Response('Missing urlSegment', { status: 400 });
    }

    const variables: GetBuildHubInspirationsQueryVariables = {
        urlSegment,
        limit,
        offset,
    };

    return await getBuildHubInspirations({ ...context, ...variables });
};
